module.exports = "data:image/jpeg;base64,77u/bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvaG90ZWwuNGVlNzQ1YTIuanBnIjs="